import { render, staticRenderFns } from "./layout-draw-input.vue?vue&type=template&id=ef2d3704"
import script from "./layout-draw-input.vue?vue&type=script&lang=js"
export * from "./layout-draw-input.vue?vue&type=script&lang=js"
import style0 from "./layout-draw-input.vue?vue&type=style&index=0&id=ef2d3704&prod&lang=scss"


/* normalize component */
import normalizer from "!D:\\wwwroot\\deepcityAI\\user-client-pc\\user-client-common-pc\\node_modules\\@vue\\vue-loader-v15\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports